import { Directive, HostListener } from '@angular/core';

/**
 * Mantém o foco no p-multiSelect enquanto o usuário mexe nele com o mouse, para o
 * (keyup.enter) do campo funcionar depois de escolher as opções.
 *
 * No PrimeNG 13 as opções da lista têm tabindex="0": o clique foca a opção, e o Enter
 * seguinte desmarca essa opção antes de o (keyup.enter) rodar. Fechar a lista clicando
 * no campo, ou remover um chip no X, tirava o foco do multiselect, e o Enter não fazia nada.
 *
 * Só cobre o painel dentro do componente: com appendTo, os cliques nas opções não passam por aqui.
 */
@Directive({
  selector: 'p-multiSelect[KeepFocus]'
})
export class MultiSelectKeepFocusDirective {

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    // O campo de busca da lista ([filter]="true") precisa receber o foco para digitar.
    if (!(event.target instanceof HTMLInputElement)) {
      event.preventDefault();
    }
  }
}
